import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { paints } from '../../../../reducers/paints/selectors';
import combineSelectors from 'utils/combineSelectors';
import { addProps, addIntlProps } from 'utils/recompose';
import messages from '../messages';
import { getDropdownOptions } from '../enhance';

const mapStateToProps = combineSelectors({
  paints,
});

const options = ({ paints, availableOptions }) =>
  getDropdownOptions(paints, availableOptions);

export default compose(
  injectIntl,
  addIntlProps({ messages, propNames: ['exteriorFormPlaceHolder'] }),
  connect(mapStateToProps),
  addProps({ options }),
);
